import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfService = () => {
  // Header is now global via App.js
  // Re-adding wrapper div for dark theme background
  return (
    <div className="bg-gradient-to-br from-gray-900 to-black text-white"> {/* Removed flex-grow */}
      {/* Main Content */}
      <main className="container mx-auto px-6 py-12 md:py-16"> {/* Removed text-white, inherited now */}
        <h1 className="text-3xl md:text-4xl font-bold mb-8 text-center">Terms of Service</h1>
        <div className="prose prose-invert max-w-3xl mx-auto text-gray-300">
          <p>Last updated: March 28, 2025</p>
          <p>
            Please read these Terms of Service ("Terms", "Terms of Service") carefully before using the Headshot AI website (the "Service") operated by Headshot AI ("us", "we", or "our").
          </p>
          <p>
            Your access to and use of the Service is conditioned on your acceptance of and compliance with these Terms. These Terms apply to all visitors, users, and others who access or use the Service.
          </p>
          <h2>Accounts</h2>
          <p>
            When you create an account with us, you must provide information that is accurate, complete, and current at all times. Failure to do so constitutes a breach of the Terms, which may result in immediate termination of your account on our Service.
          </p>
          <h2>Use of Service</h2>
          <p>
            You agree not to use the Service for any unlawful purpose or any purpose prohibited under this clause. You agree not to use the Service in any way that could damage the Service, the servers, or the general network infrastructure.
          </p>
          <h2>Intellectual Property</h2>
          <p>
            The Service and its original content (excluding Content provided by users), features, and functionality are and will remain the exclusive property of Headshot AI and its licensors. The generated headshots are provided for your use, subject to the specific license terms granted upon purchase or download [Placeholder: Specify license terms].
          </p>
          <h2>Termination</h2>
          <p>
            We may terminate or suspend access to our Service immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.
          </p>
          <h2>Disclaimer</h2>
          <p>
            Your use of the Service is at your sole risk. The Service is provided on an "AS IS" and "AS AVAILABLE" basis. The Service is provided without warranties of any kind, whether express or implied.
          </p>
          <h2>Governing Law</h2>
          <p>
            These Terms shall be governed and construed in accordance with the laws of [Placeholder: Your Jurisdiction], without regard to its conflict of law provisions.
          </p>
          <h2>Changes</h2>
          <p>
            We reserve the right, at our sole discretion, to modify or replace these Terms at any time. We will try to provide at least 30 days' notice prior to any new terms taking effect.
          </p>
          <h2>Contact Us</h2>
          <p>
            If you have any questions about these Terms, please contact us: [Placeholder: Add contact information].
          </p>
        </div>
      </main>

      {/* Simple Footer */}
      <footer className="py-6 px-6 md:px-10 text-center text-gray-400 border-t border-white/10 mt-auto">
        <p>&copy; 2025 Headshot AI. All rights reserved.</p>
      </footer>
    </div> // Close wrapper div
  );
};

export default TermsOfService;
